import {Trans} from "@i18n/client";
import React from "react";
import {useCarbonForCampusConstants} from "src/constants/CarbonForCampus";

import {Btn} from "../V5Comp";
import ColorCard from "./ColorCard";

const Benefits: React.FC = () => {
  const {benefits, ctaProps} = useCarbonForCampusConstants();

  return (
    <div className="ph8 pt10 pb30">
      <div className="maxw80 ma">
        <h2 className="mb5">
          <Trans>
            Benefits of <span className="darkerYellow">Carbon for Campus</span>
          </Trans>
        </h2>

        <div className="pv8 mb4 dg gg6 af df-sm fw">
          {benefits.map(b => (
            <ColorCard key={b.header} {...b} className="mb3-sm" />
          ))}
        </div>

        <Btn {...ctaProps} className="focus-bsDarkBlue3" />
      </div>
    </div>
  );
};

export default Benefits;
